module.exports = __webpack_public_path__ + "img/icon-model-new.dcd71958.svg";